import { MailTemplateDataType } from "../MailTemplateDataType";

export class MailTemplateConfig {
	MailTemplateConfigType: MailTemplateDataType;
}